import { ItemData } from 'core/models/Template'

export const LENS_OF_TIME_CATALOG_TYPE = 'lensOfTime' as const

export const LENS_OF_TIME_CATALOG_CONFIG = {
    type: LENS_OF_TIME_CATALOG_TYPE,
    allowEmptyList: true,
    treeView: false,
    additionalData: {},
    fixedHeader: true,
    isExistRightToolbar: false,
    hideHeader: true,
} as const

export type LensOfTimeSelectedItems = ItemData[]
